module.exports = __webpack_public_path__ + "assets/78103e01fee1b8b7a28da02e2615c446.mp3";